import dtsMark from '@/dts-mark.svg';
import { cn } from './ui';

/** "Powered by DTS LLS" credit linking to chuckgiddens.com, shown at the foot of the app's screens. */
export function PoweredBy({ compact, className }: { compact?: boolean; className?: string }) {
  return (
    <a
      href="https://chuckgiddens.com"
      target="_blank"
      rel="noopener noreferrer"
      title="Powered by DTS LLS"
      className={cn('inline-flex items-center justify-center gap-1.5 text-[11px] text-faint transition-colors hover:text-muted', className)}
    >
      <img src={dtsMark} alt="" className="h-3 w-auto opacity-70" draggable={false} />
      {!compact && <span>Powered by DTS LLS</span>}
    </a>
  );
}
